import styled from '@emotion/styled';

export const UlList = styled.ul`
  margin-top: 1rem;
  margin-bottom: 1rem;
`;
